// frontend/src/sections/admin/EODCleanupSection.js
import React, { useState } from 'react';
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export default function EODCleanupSection({ user, setMsg }) {
  const [loading, setLoading] = useState(false);

  const triggerEOD = async () => {
    if (!user || !user.tenant_id || !user.role || user.role !== 'admin') {
      setMsg({ type: 'error', text: 'User not authenticated or missing admin role for EOD.' });
      return;
    }

    setLoading(true);
    setMsg(''); // Clear previous messages

    try {
      const headers = {
        'X-User-Id': user.id,
        'X-User-Role': user.role,
        'X-Tenant-Id': user.tenant_id,
        'Content-Type': 'application/json'
      };

      const response = await axios.post(`${BASE_URL}/api/eod-cleanup`, {}, { headers });
      setMsg({ type: 'success', text: response.data.message || 'EOD Cleanup successful!' });
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.message || "An unknown error occurred.";
      setMsg({ type: 'error', text: `EOD Cleanup Failed: ${errorMessage}` });
      console.error("EOD Cleanup Error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-section">
      <h3>End of Day Cleanup</h3>
      <p>Click the button below to reset waiting and skipped tokens for your tenant to 'expired'.</p>
      <button onClick={triggerEOD} disabled={loading} className="admin-button">
        {loading ? 'Running EOD...' : 'Run End-of-Day Cleanup'}
      </button>
    </div>
  );
}